import React from "react";
import whatsappIcon from "../assets/images/whatsapp.svg";
import { WHATSAPP_CHAT_URL } from "./WhatsAppPurchaseBanner";

const WhatsAppFloatingCta = () => {
  return (
    <div className="fixed-whatsapp-cta">
      <span className="fixed-whatsapp-cta__text">
        Purchase eSIM by WhatsApp
      </span>
      <a
        className="fixed-whatsapp-cta__icon"
        href={WHATSAPP_CHAT_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="Purchase eSIM by WhatsApp"
      >
        <img src={whatsappIcon} alt="" />
      </a>
    </div>
  );
};

export default WhatsAppFloatingCta;
